import axios from 'axios'

function getOPDActivitiesByHN () {
  let key = localStorage.getItem('sessionKey')
  return axios.get(`${process.env.VUE_APP_Q_OPD_API}/opd/q?sessionKey=${key}`)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err)
      return Promise.reject(err.response)
    })
}

function getRegistrationActivities () {
  let key = localStorage.getItem('sessionKey')
  return axios.get(`${process.env.VUE_APP_Q_REGISTRATION_API}/registration/q?sessionKey=${key}`)
    .then((res) => res.data)
    .catch((err) => {
      console.log('err: ', err)
      return Promise.reject(err.response)
    })
}

function getPharmacyActivities () {
  let key = localStorage.getItem('sessionKey')
  return axios.get(`${process.env.VUE_APP_Q_PHARMACY_API}/pharmacy/q?sessionKey=${key}`)
    .then((res) => res.data)
    .catch((err) => {
      console.log('err: ', err)
      return Promise.reject(err.response)
    })
  // return Promise.resolve({
  //   hn: '51222888',
  //   pid: '1400808300977',
  //   patientName: 'ธัญญาธร แสงภักดีธรรม',
  //   gender: 'male',
  //   activities: [
  //     {
  //       id: '1234444',
  //       serviceType: 'pharmacy',
  //       qType: 'คิวรับยา',
  //       qSubType: 'ยาด่วน',
  //       qNumber: 'A039',
  //       location: 'อาคารเเฉลิมพระเกียรติชั้น 1',
  //       serviceUnitName: 'ห้องยาเฉลิมพระเกียรติชั้น 1',
  //       channel: '14 - 15',
  //       case: 3,
  //       caseStatus: 'blue',
  //       caseMessage: 'ยาค้างรับ',
  //       caseDescription: 'ติดต่อเจ้าหน้าที่ช่อง 41',
  //       instructions: [
  //         {
  //           iconPath: 'payment.png',
  //           title: 'รอเรียกคิวการเงินที่ช่อง 16 - 20'
  //         },
  //         {
  //           iconPath: 'drug.png',
  //           title: 'รอเรียกคิวรับยาทีช่อง 30 - 40'
  //         }
  //       ]
  //     }
  //   ]
  // })
}

function getCashierActivities () {
  let key = localStorage.getItem('sessionKey')
  return axios.get(`${process.env.VUE_APP_Q_CASHIER_API}/cashier/q?sessionKey=${key}`)
    .then((res) => res.data)
    .catch((err) => {
      console.log('err: ', err)
      return Promise.reject(err.response)
    })
  // return Promise.resolve({
  //   hn: '51222888',
  //   pid: '1400808300977',
  //   patientName: 'ธัญญาธร แสงภักดีธรรม',
  //   gender: 'male',
  //   activities: [
  //     {
  //       id: '1234445',
  //       serviceType: 'cashier',
  //       qType: 'คิวการเงิน',
  //       qSubType: '',
  //       qNumber: 'A039',
  //       location: 'อาคารเเฉลิมพระเกียรติชั้น 1',
  //       serviceUnitName: 'ห้องยาเฉลิมพระเกียรติชั้น 1',
  //       channel: '30 - 49',
  //       case: 2,
  //       caseStatus: 'green',
  //       caseMessage: 'เสร็จสิ้น',
  //       caseDescription: 'กรุณาทำแบบสอบถามประเมินความพึงพอใจ',
  //       instructions: [
  //         {
  //           iconPath: 'payment.png',
  //           title: 'รอเรียกคิวการเงินที่ช่อง 16 - 20'
  //         },
  //         {
  //           iconPath: 'drug.png',
  //           title: 'รอเรียกคิวรับยาทีช่อง 30 - 40'
  //         }
  //       ]
  //     }
  //   ]
  // })
}

export {
  getOPDActivitiesByHN,
  getRegistrationActivities,
  getPharmacyActivities,
  getCashierActivities
}
